import React, { CSSProperties } from "react";
import { SectionHeader } from "@/shell/components/SectionHeader";
import { CustomerValueConcentration } from "@/features/orders-analytics/types/orders-analytics.types";
import { formatters } from "@/features/orders-analytics/utils/formatters";

type Props = {
    concentration: CustomerValueConcentration;
};

const tileTone = (share: number): CSSProperties => {
    if (share >= 60) return { color: "var(--vb-error-500)" };
    if (share >= 30) return { color: "var(--vb-warning-500)" };
    return {};
};

export const ValueConcentrationSection: React.FC<Props> = ({ concentration }) => {
    const tiles = [
        ...concentration.tops.map((top) => ({
            label: `Top ${top.topCount} account${top.topCount === 1 ? "" : "s"}`,
            share: top.revenueShare,
        })),
        { label: "Top 10% of accounts", share: concentration.top10Share },
    ];

    return (
        <section className="section">
            <SectionHeader
                title="Revenue concentration"
                meta="share of revenue held by the highest-value accounts"
            />
            <div className="grid-4">
                {tiles.map((tile) => (
                    <div key={tile.label} className="card tile">
                        <div className="tile__label">{tile.label}</div>
                        <div className="tile__value num" style={tileTone(tile.share)}>
                            {formatters.formatPercentage(tile.share)}
                        </div>
                        <div className="tile__sub">of total business revenue</div>
                    </div>
                ))}
            </div>
        </section>
    );
};
